import { ErrorWithFields as r } from "./index7.mjs";
class e extends r {
}
export {
  e as ConflictError
};
